export default __webpack_public_path__ + "static/media/icon-zalo.b2383fdc.png";